var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('v-sheet',{staticClass:"clipDetail-clip_video home_video"},[(_vm.showPlayback && !_vm.clipListLoading)?_c('ClipVideo'):_c('clip-video-skeleton')],1),_c('ClipList',{staticClass:"home_events"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }